module.exports = __webpack_public_path__ + "img/pasyb.c5646314.png";